// extracted by mini-css-extract-plugin
module.exports = {"TextLayout":"tooltip_TextLayout__3lthh","GrowthText":"tooltip_GrowthText__DG73R"};